/**
 * Lawyer Type Definitions
 */

export enum LawyerCategory {
  Plaintiff = 0,
  Defendant = 1,
}

export interface Lawyer {
  id: number;
  certificateApplicationId: number;
  certificateApplicationFormNo: string;
  name: string;
  primaryPhone: string;
  secondaryPhone?: string;
  email?: string;
  address: string;
  category: LawyerCategory;
  createdBy: number;
  createdByName: string;
  createdAt: string;
}

export interface CreateLawyerDto {
  certificateApplicationId: number;
  name: string;
  primaryPhone: string;
  secondaryPhone?: string;
  email?: string;
  address: string;
  category: LawyerCategory;
}

export interface UpdateLawyerDto {
  id: number;
  certificateApplicationId: number;
  name: string;
  primaryPhone: string;
  secondaryPhone?: string;
  email?: string;
  address: string;
  category: LawyerCategory;
}
